<template>
  <div style="margin-top: 25px; margin-bottom: 100px">
    <v-dialog v-model="operator_dialog" width="500" persistent>
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="250"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold">{{
            action == "edit" ? "Edit Operator" : "Create Operator"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="grey" dark @click="cancel_operator_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="ma-5 overflow-y-auto"
          style="text-align: left; max-height: 450px"
        >
          <v-form ref="form">
            <div>
              <p style="font-weight: bold">Username:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_username"
                  single-line
                  outlined
                  dense
                  :readonly="!isEditor"
                  @input="clear_error_message('username')"
                  :error-messages="username_error_message"
                  :rules="[
                    () => !!selected_username || 'Username is required',
                    () =>
                      selected_username.length >= 5 || 'At least 5 characters',
                    () =>
                      !selected_username.includes(' ') ||
                      'No whitespace is allowed',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Email Address:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_email"
                  single-line
                  outlined
                  dense
                  :readonly="!isEditor"
                  @input="clear_error_message('email')"
                  :error-messages="email_error_message"
                  :rules="[
                    () => !!selected_email || 'Email is required',
                    () =>
                      validate_email(selected_email) || 'E-mail must be valid',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Country Code:</p>
              <div style="margin-top: -10px">
                <v-autocomplete
                  v-model="selected_country_code"
                  :items="country_code_list"
                  single-line
                  outlined
                  dense
                  :readonly="!isEditor"
                  @input="clear_error_message('phone_number')"
                  :error-messages="phone_number_error_message"
                  :rules="[
                    () => !!selected_country_code || 'Country code is required',
                  ]"
                ></v-autocomplete>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Phone Number:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_phone_number"
                  single-line
                  outlined
                  dense
                  hint="e.g. 163322123"
                  :readonly="!isEditor"
                  @input="clear_error_message('phone_number')"
                  :error-messages="phone_number_error_message"
                  :rules="[
                    () => !!selected_phone_number || 'This field is required',
                    () =>
                      selected_phone_number.length >= 9 ||
                      'Invalid phone number',
                    () =>
                      /^\d+$/.test(selected_phone_number) ||
                      'Invalid phone number',
                    () =>
                      !/\s/g.test(selected_phone_number) ||
                      'Phone number can\'t contain white space',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">New Password:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="password"
                  type="password"
                  single-line
                  :readonly="!isEditor"
                  outlined
                  dense
                  :rules="[
                    () =>
                      validate_password_length(password) ||
                      'At least 9 characters',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Confirm Password:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="confirm_password"
                  type="password"
                  :readonly="!isEditor"
                  single-line
                  outlined
                  dense
                  :rules="[
                    () =>
                      validate_password_length(password) ||
                      'At least 9 characters',
                    () =>
                      confirm_password == password || 'Password does not match',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Company:</p>
              <div style="margin-top: -10px; margin-bottom: 25px">
                <v-autocomplete
                  v-model="selected_company_name"
                  :items="company_name_list"
                  placeholder="Leave Empty if is NuVending Machine"
                  single-line
                  hide-details="auto"
                  outlined
                  single
                  dense
                  :readonly="current_user_company_doc_id != ''"
                ></v-autocomplete>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Company Duty:</p>
              <div style="margin-top: -10px">
                <v-combobox
                  v-model="selected_company_role_list"
                  :items="company_role_list"
                  placeholder="Operator Authority Level"
                  single-line
                  outlined
                  :readonly="!isEditor"
                  multiple
                  dense
                ></v-combobox>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Portal Roles:</p>
              <div style="margin-top: -10px">
                <v-combobox
                  v-model="selected_role_list"
                  :items="role_list"
                  placeholder="Role"
                  :readonly="!isEditor"
                  single-line
                  outlined
                  multiple
                  dense
                ></v-combobox>
              </div>
            </div>
          </v-form>
        </div>
        <v-card-actions>
          <v-btn
            color="primary"
            class="white--text"
            block
            depressed
            style="text-transform: capitalize"
            @click="update_operator"
            :loading="is_submitting"
            :disabled="is_submitting"
            v-if="isEditor"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="operator_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          @click:row="view_operator"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Operators"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="isEditor">
                <v-btn
                  depressed
                  color="primary"
                  dark
                  style="text-transform: capitalize"
                  @click="open_operator_dialog"
                >
                  <v-icon left dark> mdi-plus </v-icon>
                  Create Operator
                </v-btn>
              </div>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        { text: "Username", value: "username", sortable: true, divider: true },
        { text: "Phone Number", value: "full_phone_number", divider: true },
        {
          text: "Email Address",
          value: "email_address",
          sortable: true,
          divider: true,
        },
        { text: "Roles", value: "roles", sortable: true, divider: true },
      ],
      operator_list: [],
      table_loading: false,
      search: "",
      action: "",
      username_error_message: "",
      email_error_message: "",
      phone_number_error_message: "",
      selected_operator_id: "",
      selected_username: "",
      original_username: "",
      selected_email: "",
      original_email: "",
      selected_country_code: "",
      selected_phone_number: "",
      original_full_phone_number: "",
      password: "",
      confirm_password: "",
      selected_role_list: [],
      company_role_list: [],
      company_role_detail_list: [],
      selected_company_role_list: [],
      selected_company_role_doc_id_list: [],
      selected_company_name: "",
      company_name_list: [],
      company_details_list: [],
      selected_company_doc_id: "",
      operator_dialog: false,
      is_submitting: false,
      country_code_list: ["Malaysia +60"],
      role_list: ["refiller", "technician", "location", "seller", "admin"],

      current_user_permission: [],
      current_user_company_doc_id: "",
      isEditor: false,
    };
  },
  methods: {
    validate_password_length(password) {
      if (this.action == "create") {
        if (password == null || password == "" || password.length < 9) {
          return false;
        } else {
          return true;
        }
      } else {
        if (password == null || password == "") {
          return true;
        } else {
          if (password.length >= 9) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    validate_email(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    async create_operator() {
      this.is_submitting = true;
      var result = await this.validate_duplication([
        "username",
        "email",
        "phone_number",
      ]);
      if (result) {
        // create user
        var response = await this.send_http_request("operatorSignUp", {
          username: this.selected_username,
          email_address: this.selected_email,
          country_code: this.selected_country_code.split(" ")[1],
          phone_number: this.selected_phone_number,
          password: this.password,
          user_type: this.selected_role_list,
          role_list: this.selected_company_role_doc_id_list,
          company_doc_id:
            this.current_user_company_doc_id == ""
              ? this.selected_company_doc_id
              : this.current_user_company_doc_id,
        });
        if (response.data.status == "OK") {
          this.is_submitting = false;
          this.cancel_operator_dialog();
          this.load_operator();
          this.show_snack_bar("success", "Operator Created");
        } else {
          this.is_submitting = false;
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    async edit_operator() {
      this.is_submitting = true;
      var validation_list = [];
      if (this.selected_username != this.original_username) {
        validation_list.push("username");
      }
      if (this.selected_email != this.original_email) {
        validation_list.push("email");
      }
      if (
        this.original_full_phone_number !=
        `${this.selected_country_code.split("+")[1]}${
          this.selected_phone_number
        }`
      ) {
        validation_list.push("phone_number");
      }
      var result = await this.validate_duplication(validation_list);
      if (result) {
        // edit user
        var response = await this.send_http_request("updateOperator", {
          operator_id: this.selected_operator_id,
          username: this.selected_username,
          email_address: this.selected_email,
          country_code: this.selected_country_code.split(" ")[1],
          phone_number: this.selected_phone_number,
          password: this.password == null ? "" : this.password,
          user_type: this.selected_role_list,
          company_doc_id:
            this.current_user_company_doc_id == ""
              ? this.selected_company_doc_id
              : this.current_user_company_doc_id,
          role_list: this.selected_company_role_doc_id_list,
        });
        if (response.data.status == "OK") {
          this.is_submitting = false;
          this.cancel_operator_dialog();
          this.load_operator();
          this.show_snack_bar("success", "Operator Updated");
        } else {
          this.is_submitting = false;
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    update_operator() {
      if (
        this.selected_company_name != "" &&
        this.selected_company_name != "Nu Vending"
      ) {
        this.selected_company_doc_id = this.company_details_list.find(
          (o) => o.company_name === this.selected_company_name
        ).company_doc_id;
      } else {
        this.selected_company_doc_id = "";
      }
      if (this.selected_company_role_list.length > 0) {
        this.selected_company_role_doc_id_list = [];
        this.selected_company_role_list.forEach((role) => {
          this.selected_company_role_doc_id_list.push(
            this.company_role_detail_list.find((o) => o.role_name === role).id
          );
        });
      }
      if (this.$refs.form.validate()) {
        if (this.action == "create") {
          this.create_operator();
        } else {
          this.edit_operator();
        }
      }
    },
    clear_error_message(type) {
      if (type == "username") {
        this.username_error_message = "";
      } else if (type == "email") {
        this.email_error_message = "";
      } else if (type == "phone_number") {
        this.phone_number_error_message = "";
      }
    },
    cancel_operator_dialog() {
      this.selected_operator_id = "";
      this.selected_username = "";
      this.original_username = "";
      this.selected_email = "";
      this.original_email = "";
      this.selected_country_code = "";
      this.selected_phone_number = "";
      this.original_full_phone_number = "";
      this.password = "";
      this.confirm_password = "";
      this.selected_company_name = "";
      this.selected_role_list = [];
      this.operator_dialog = false;
      this.$refs.form.resetValidation();
    },
    async load_company_options() {
      var response = await this.send_http_request(
        "getAllCompaniesWithCompanyID",
        {
          company_doc_id: this.current_user_company_doc_id,
        }
      );
      this.company_details_list = response.data.result;
      this.company_name_list = ["Nu Vending"];
      this.company_details_list.forEach((option) => {
        this.company_name_list.push(option.company_name);
      });
    },
    load_operator() {
      this.table_loading = true;
      this.send_http_request("getAllOperatorsWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.operator_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    load_company_roles() {
      this.table_loading = true;
      this.send_http_request("getAllRoles", {})
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.company_role_list = [];
            this.company_role_detail_list = response.data.result;
            this.company_role_detail_list.forEach((item) => {
              this.company_role_list.push(item.role_name);
            });
            this.company_role_list = this.company_role_list.sort();
          } else {
            console.log("error");
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    view_operator(value) {
      this.action = "edit";
      this.selected_operator_id = value.operator_id;
      this.selected_username = value.username;
      this.original_username = value.username;
      this.selected_email = value.email_address;
      this.original_email = value.email_address;
      let company_role_list = value.role_list != null ? value.role_list : [];
      this.selected_company_role_list = [];
      company_role_list.forEach((role_id) => {
        this.selected_company_role_list.push(
          this.company_role_detail_list.find((o) => o.id === role_id).role_name
        );
      });
      let selected_company_id =
        value.company_doc_id != null ? value.company_doc_id : "";
      if (selected_company_id != "") {
        this.selected_company_name = this.company_details_list.find(
          (o) => o.company_doc_id === selected_company_id
        ).company_name;
      } else {
        this.selected_company_name = "";
      }

      this.selected_phone_number =
        value.phone_number != null ? value.phone_number : "";
      var country_code_index = this.country_code_list.findIndex((x) =>
        x.includes(value.country_code)
      );
      if (country_code_index > -1) {
        this.selected_country_code = this.country_code_list[country_code_index];
      }
      this.original_full_phone_number = value.full_phone_number;
      this.selected_role_list = value.roles;
      this.operator_dialog = true;
    },
    open_operator_dialog() {
      this.action = "create";
      this.selected_company_doc_id = this.current_user_company_doc_id;
      if (this.selected_company_doc_id != "") {
        this.selected_company_name = this.company_details_list.find(
          (o) => o.company_doc_id === this.selected_company_doc_id
        ).company_name;
      }
      this.operator_dialog = true;
    },
    validate_duplication(required_validation_list) {
      return new Promise((res, rej) => {
        var promises = [];

        if (required_validation_list.includes("username")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsOperatorUsernameTaken", {
                username: this.selected_username,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.username_error_message = "Username has been taken";
                  } else {
                    this.username_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        if (required_validation_list.includes("email")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsOperatorEmailTaken", {
                email: this.selected_email,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.email_error_message = "Email has been taken";
                  } else {
                    this.email_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        if (required_validation_list.includes("phone_number")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsOperatorPhoneTaken", {
                phone_number: `${this.selected_country_code.split("+")[1]}${
                  this.selected_phone_number
                }`,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.phone_number_error_message =
                      "Phone number has been taken";
                  } else {
                    this.phone_number_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        Promise.all(promises)
          .then(() => {
            res(
              this.username_error_message == "" &&
                this.email_error_message == "" &&
                this.phone_number_error_message == ""
            );
          })
          .catch((error) => {
            rej(error);
          });
      });
    },
  },
  mounted() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    this.load_company_options();
    this.load_company_roles();
    this.load_operator();
    this.isEditor =
      this.current_user_company_doc_id == "" ||
      (this.current_user_company_doc_id != "" &&
        (this.current_user_permission.includes("Wbl2TAMLlfwkX8QDwztB") ||
          this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")));
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>